import { callAPI } from "../../network/networkConnection";

const BASE_URL = process.env.REACT_APP_APIUrl + "admin";

/**
 * Get cron logs with pagination and filters
 */
const getLogs = (params = {}) => {
  const queryString = Object.keys(params).length
    ? "?" + new URLSearchParams(params).toString()
    : "";
  return callAPI(
    `${BASE_URL}/cron-logs${queryString}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get single cron log details
 */
const getLogDetails = (id) => {
  return callAPI(
    `${BASE_URL}/cron-logs/${id}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get currently running jobs
 */
const getRunningJobs = () => {
  return callAPI(
    `${BASE_URL}/cron-logs/running`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get cron log statistics
 */
const getStats = () => {
  return callAPI(
    `${BASE_URL}/cron-logs/stats`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Cleanup old logs
 */
const cleanup = (daysOld = 30, deleteAll = false) => {
  return callAPI(
    `${BASE_URL}/cron-logs/cleanup`,
    "DELETE",
    { "Content-Type": "application/json" },
    JSON.stringify({ daysOld, deleteAll })
  );
};

/**
 * Delete a single log
 */
const deleteLog = (id) => {
  return callAPI(
    `${BASE_URL}/cron-logs/${id}`,
    "DELETE",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Trigger pricing update for all products
 */
const triggerPricingUpdateAll = (params = {}) => {
  return callAPI(
    `${BASE_URL}/pricing/update-all`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(params)
  );
};

/**
 * Get all pricing algorithms
 */
const getPricingAlgorithms = () => {
  return callAPI(
    `${BASE_URL}/pricing-algorithms`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get supported domains
 */
const getSupportedDomains = () => {
  return callAPI(
    `${BASE_URL}/pricing-algorithms/domains`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get pricing update status
 */
const getPricingStatus = () => {
  return callAPI(
    `${BASE_URL}/pricing/status`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Cancel running pricing update
 */
const cancelPricingUpdate = (withRollback = false) => {
  return callAPI(
    `${BASE_URL}/pricing/cancel`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify({ withRollback })
  );
};

/**
 * Rollback prices to original
 */
const rollbackPrices = () => {
  return callAPI(
    `${BASE_URL}/pricing/rollback`,
    "POST",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Trigger pricing update for specific SKUs
 */
const triggerPricingUpdateSkus = (params = {}) => {
  return callAPI(
    `${BASE_URL}/pricing/update-skus`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(params)
  );
};

export const cronLogService = {
  getLogs,
  getLogDetails,
  getRunningJobs,
  getStats,
  cleanup,
  deleteLog,
  triggerPricingUpdateAll,
  triggerPricingUpdateSkus,
  getPricingAlgorithms,
  getSupportedDomains,
  getPricingStatus,
  cancelPricingUpdate,
  rollbackPrices,
};
